import { action, thunk, persist } from 'easy-peasy';
import { httpGetPortfoliosUnmadeDividendTransactions } from "services/portfolios"

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
  // "Näytä myös vanhat" on the Käsittele osingot list. In the store, not in the list, so
  // that undoing a dividend that ends up behind the cutoff can turn it on (#1434), and the
  // reloads TransactionsList makes without a payload follow the toggle.
  showOlder: false,
  setShowOlder: action((state, payload) => {
    state.showOlder = Boolean(payload)
  }),
  // My portfolios list
  unmadeDividendTransactions: [],
  setUnmadeDividendTransactions: action((state, payload) => {
    if (payload) {
      state.unmadeDividendTransactions = payload
    }
  }),
  getUnmadeDividendTransactions: thunk(async (actions, payload, { getState }) => {
    actions.setLoading(true)
    const showOlder = payload?.showOlder ?? getState().showOlder;
    const params = showOlder ? { show_older: true } : undefined;
    return httpGetPortfoliosUnmadeDividendTransactions(params).then(response => {
      if (response.status === 200 && response?.data) {
        actions.setLoading(false)
        actions.setUnmadeDividendTransactions(response.data)
        if (response?.data.length > 0) {
          actions.setCount(response?.data.length)
        }
        else {
          actions.setCount(0)
        }
      }
    }, error => {

    }).finally(() => {
      actions.setLoading(false)
    })

  }),
  // Selected portfolio

};

export default model;